<template>
  <base-campaign-targeting-rule>
    <div>When a visitor is about to leave your site.</div>
  </base-campaign-targeting-rule>
</template>

<script>
import BaseCampaignTargetingRule from "@/components/campaign-targeting-rules/BaseCampaignTargetingRule"
import targetingRuleMixin from "@/mixins/targeting-rule-mixin"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"
const mixin = targetingRuleMixin("when", targetingRuleNames.whenRules.exitIntent)

export default {
  name: "TargetingExitIntent",
  components: { BaseCampaignTargetingRule },
  mixins: [mixin]
}
</script>
